import { Button, Tooltip } from "antd";
import { FilterFilled, FilterOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reduxStore/reducers/rootReducer";
import { toggleInventoryFilter } from "../../reduxStore/reducers/chainInventoryFilterSlice";

const ChainInventoryToggle = () => {
  const dispatch = useDispatch();
  const isFilterActive = useSelector((state: RootState) => state.chainInventoryFilter.isFilterActive);

  const toggleView = () => {
    dispatch(toggleInventoryFilter());
  };
  return (
      <Tooltip placement="left" title="Inventory Filter">
        <Button 
          icon={isFilterActive ? <FilterFilled style={{ color: 'white', fontSize: 20 }} /> : <FilterOutlined style={{ color: 'white', fontSize: 20 }} />}
          onClick={toggleView}
          style={{ background: 'none', border: 'none', padding: 0 }}
        />
      </Tooltip>
  );
};

export default ChainInventoryToggle;
